import ChcekEvent from "../../../../src/events/2021/10/event-dabang-check/main";
import * as React from 'react';
export default {
  ChcekEvent,
  React
};